(function() {
      'use strict';

      // --- Sticky CTA visibility ---
      var stickyCta = document.getElementById('stickyCta');
      var heroSection = document.querySelector('.hero-section');
      var offersSection = document.getElementById('offers');

      function updateStickyCta() {
        if (!heroSection || !offersSection || !stickyCta) return;
        var heroBottom = heroSection.getBoundingClientRect().bottom;
        var offersTop = offersSection.getBoundingClientRect().top;
        var windowHeight = window.innerHeight;

        // Show sticky CTA when hero is scrolled past and offers section is not yet in view
        if (heroBottom < 0 && offersTop > windowHeight) {
          stickyCta.classList.add('visible');
        } else {
          stickyCta.classList.remove('visible');
        }
      }

      window.addEventListener('scroll', updateStickyCta, { passive: true });
      updateStickyCta();

      // --- Sticky Header visibility ---
      var stickyHeader = document.getElementById('stickyHeader');
      var logoBar = document.querySelector('.logo-bar');

      function updateStickyHeader() {
        if (!stickyHeader || !logoBar) return;
        var logoBottom = logoBar.getBoundingClientRect().bottom;
        if (logoBottom < 0) {
          stickyHeader.classList.add('visible');
        } else {
          stickyHeader.classList.remove('visible');
        }
      }

      window.addEventListener('scroll', updateStickyHeader, { passive: true });
      updateStickyHeader();

      // --- Image Gallery Carousel ---
      var currentSlide = 0;
      var totalSlides = document.querySelectorAll('.gallery-slide').length;
      var track = document.getElementById('galleryTrack');
      var thumbs = document.querySelectorAll('.gallery-thumb');

      function goToSlide(index) {
        if (index < 0) index = totalSlides - 1;
        if (index >= totalSlides) index = 0;
        currentSlide = index;
        track.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        if (thumbs[currentSlide]) thumbs[currentSlide].classList.add('active');
      }

      var arrowLeft = document.querySelector('.gallery-arrow-left');
      var arrowRight = document.querySelector('.gallery-arrow-right');
      if (arrowLeft) {
        arrowLeft.addEventListener('click', function() { goToSlide(currentSlide - 1); });
      }
      if (arrowRight) {
        arrowRight.addEventListener('click', function() { goToSlide(currentSlide + 1); });
      }
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          goToSlide(parseInt(this.dataset.slide));
        });
      });

      // --- Variant + Checkout Config ---
      var variants = {
        1: { id: 46004120682649, sellingPlan: 2498723993 },
        2: { id: 46004120715417, sellingPlan: 2498723993 }
      };

      // --- Plan button selection ---
      document.querySelectorAll('.plan-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          document.querySelectorAll('.plan-btn').forEach(function(b) { b.classList.remove('selected'); });
          btn.classList.add('selected');
        });
      });

      // --- Dynamic pricing based on qty + plan selection ---
      var pricing = {
        1: {
          subscribe: { price: '$49.99', original: '$97.99', perDay: '$1.67/day', subtitle: '1 tub each 30 days', eyebrow: 'Most Popular: Get 49% Off' },
          onetime:   { price: '$59.99', original: '$97.99', perDay: '$2.00/day', subtitle: '1 tub delivered once' }
        },
        2: {
          subscribe: { price: '$47.49', original: '$97.99', perDay: '$1.58/day', subtitle: '2 tubs each 30 days', eyebrow: 'Best Value: Get 52% Off' },
          onetime:   { price: '$56.99', original: '$97.99', perDay: '$1.90/day', subtitle: '2 tubs delivered once' }
        }
      };

      function updatePricing() {
        var qty = document.querySelector('input[name="qty-selector"]:checked').value;
        var data = pricing[qty];
        if (!data) return;

        var subBtn = document.querySelector('[data-plan="subscribe"]');
        var otBtn = document.querySelector('[data-plan="onetime"]');

        subBtn.querySelector('.plan-subtitle').textContent = data.subscribe.subtitle;
        subBtn.querySelector('.plan-price-current').textContent = data.subscribe.price;
        subBtn.querySelector('.plan-price-per-day').textContent = data.subscribe.perDay;
        var subOrig = subBtn.querySelector('.plan-price-original');
        if (subOrig) subOrig.textContent = data.subscribe.original;
        var subEye = subBtn.querySelector('.plan-eyebrow-banner');
        if (subEye) subEye.textContent = data.subscribe.eyebrow;

        otBtn.querySelector('.plan-subtitle').textContent = data.onetime.subtitle;
        otBtn.querySelector('.plan-price-current').textContent = data.onetime.price;
        otBtn.querySelector('.plan-price-per-day').textContent = data.onetime.perDay;
        var otOrig = otBtn.querySelector('.plan-price-original');
        if (otOrig) {
          otOrig.textContent = data.onetime.original;
          otOrig.style.display = data.onetime.original ? '' : 'none';
        }
      }

      document.querySelectorAll('.qty-input').forEach(function(input) {
        input.addEventListener('change', function() {
          updatePricing();
          var badge = document.getElementById('qtySaveBadge');
          var qty = document.querySelector('input[name="qty-selector"]:checked').value;
          if (qty === '2') { badge.classList.add('visible'); } else { badge.classList.remove('visible'); }
        });
      });

      // --- Checkout: Add to cart and redirect ---
      function goToCheckout() {
        var qty = document.querySelector('input[name="qty-selector"]:checked').value;
        var plan = document.querySelector('.plan-btn.selected').dataset.plan;
        var v = variants[qty];
        if (!v) return;

        var body = { items: [{ id: v.id, quantity: 1 }] };
        if (plan === 'subscribe') {
          body.items[0].selling_plan = v.sellingPlan;
        }

        fetch('/cart/clear.js', { method: 'POST' })
          .then(function() {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(body)
            });
          })
          .then(function(r) { return r.json(); })
          .then(function() { window.location.href = '/checkout'; })
          .catch(function() { window.location.href = '/checkout'; });
      }

      var buyboxCta = document.getElementById('buyboxCta');
      if (buyboxCta) buyboxCta.addEventListener('click', goToCheckout);

      // Wire all CTA buttons/links that point to #offers to scroll, but header/sticky CTAs go to checkout
      document.querySelectorAll('.sticky-header-cta, .sticky-cta .cta-button').forEach(function(el) {
        el.addEventListener('click', function(e) {
          e.preventDefault();
          var offersEl = document.getElementById('offers');
          if (offersEl) {
            var top = offersEl.getBoundingClientRect().top + window.pageYOffset - 20;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        });
      });

      // --- Buybox Accordions (detail panels) ---
      document.querySelectorAll('.buybox-accord-trigger').forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          var item = trigger.parentElement;
          var content = item.querySelector('.buybox-accord-content');
          var inner = content.querySelector('.buybox-accord-inner');
          var isOpen = item.classList.contains('open');

          // Close all buybox accordions
          document.querySelectorAll('.buybox-accord').forEach(function(acc) {
            acc.classList.remove('open');
            acc.querySelector('.buybox-accord-trigger').setAttribute('aria-expanded', 'false');
            acc.querySelector('.buybox-accord-content').style.maxHeight = '0';
          });

          if (!isOpen) {
            item.classList.add('open');
            trigger.setAttribute('aria-expanded', 'true');
            content.style.maxHeight = inner.scrollHeight + 'px';
          }
        });
      });

      // --- Review "Show More" toggle ---
      (function() {
        var btn = document.querySelector('.reviews-load-more-btn');
        if (!btn) return;
        var list = document.querySelector('.review-list');
        var cards = list ? list.querySelectorAll('.review-card') : [];
        var showing = 4;
        cards.forEach(function(card, i) {
          if (i >= showing) card.style.display = 'none';
        });
        btn.addEventListener('click', function() {
          cards.forEach(function(card) { card.style.display = ''; });
          btn.style.display = 'none';
        });
      })();

      // --- Smooth scroll for anchor links ---
      document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
        anchor.addEventListener('click', function(e) {
          var target = document.querySelector(this.getAttribute('href'));
          if (target) {
            e.preventDefault();
            var top = target.getBoundingClientRect().top + window.pageYOffset - 20;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        });
      });

      // --- Signup form ---
      var signupForm = document.getElementById('signupForm');
      if (signupForm) {
        signupForm.addEventListener('submit', function(e) {
          e.preventDefault();
          var input = this.querySelector('input');
          var btn = this.querySelector('button');
          btn.textContent = 'Check your inbox for your discount code';
          btn.style.background = '#fef0f3';
          btn.style.color = '#c94b6e';
          input.value = '';
          setTimeout(function() {
            btn.textContent = 'Unlock My Discount';
            btn.style.background = '';
            btn.style.color = '';
          }, 3000);
        });
      }

    })();